import { scrollToElement } from '../helpers/scrollToElement';
import { isMobile } from '../helpers/isMobile';

/**
 * Toggles filter menu on mobile screens.
 * @param {Object} classObj - class instance
 * @param {Boolean} toggle
 */
export function toggleMobileMenu(classObj, toggle) {
  classObj.isOpen = typeof toggle === 'boolean' ? toggle : !classObj.isOpen;
  $('.js-table-filter-toggle').toggleClass('icon-validation-cross', classObj.isOpen);
  $('.table-filter-toggle-icon').toggleClass('hide', classObj.isOpen);
  $('body').toggleClass('u-overflow-y-hidden', classObj.isOpen);
  if (classObj.isOpen) {
    renderActiveFiltersFromState(classObj.state);
  } else {
    isMobile() && scrollToElement($('#table-filter'));
  }
  $('.js-table-filter').toggleClass('table-filter--is-active', classObj.isOpen);
}

/**
 * Returns the instance of the data table API.
 * @returns {Object} The data table API instance.
*/
let dataTableInstance = null;

export function tableAPI() {
  if (!dataTableInstance) {
    dataTableInstance = $($('.js-table')[0]).dataTable({'bPaginate': false, 'bDestroy': true}).api();
  }

  return dataTableInstance;
}

/**
 * Display active filter indicator
 * @param {JQuery} $container
 * @param {String} filterLabel - label visible on ui
 * @param {String} filterName - used to populate data-attribute
 */
export function appendActiveFiltersIndication($container, filterLabel, filterName) {
  $container.append(
    `<span
      class="table-filter-single-active js-table-filter-single-active"
      data-filter-name="${filterName}"
    >${filterLabel}</span>`);
}

/**
 * Disable all active filters
 */
export function resetFiltersDom() {
  $('.js-table-filter').removeClass('table-filter--has-applied-filters');
  $('.table-filter-item--is-active').removeClass('table-filter-item--is-active');
  $('.table-filter-item--is-applied').removeClass('table-filter-item--is-applied');
  $('.table-filter-btn--is-active').removeClass('table-filter-btn--is-active');
  $('.js-table-filter-btn').removeAttr('disabled');
  $('.js-table-filter-item-active').empty();
  $('.js-table-filter-applied-item').remove();
  $('.js-table-filter-nothing-applied').removeClass('u-display-none');
  $('.js-table-filter-icon')
    .removeClass('icon-arrow-up')
    .addClass('icon-arrow-down');
}

/**
 * Appends single active filter to the dom.
 * @param {String} groupName - Filter group name
 * @param {Object} filter - Filter object containg label and name
 * @param {JQuery} $filterGroup - Filter group jquery collection
 */
function appendSingleActiveFilter(groupName, filter, $filterGroup) {
  const name = filter.name;
  appendActiveFiltersIndication($filterGroup.find('.js-table-filter-item-active'), filter.label, name);
  const label = `<span>${filter.label}</span>`;
  $('.js-table-filter-applied-list').append(
    `<div class="table-filter-btn js-table-filter-applied-item" data-filter-group=${groupName}>
      ${label}
      <button
        class="table-filter-toggle icon icon-validation-cross u-cursorPointer
          js-table-filter-deactivate-filter"
        data-filter-name="${filter.name}" filterColumn="${filter.filterColumn}"
      ></button>
    </div>`
  );
}

/**
 * Update display of the filters from the class instance state
 * @param {Object} state
 */
export function renderActiveFiltersFromState(state) {
  resetFiltersDom();

  //  Remove active state label from all filter groups
  $('.js-table-filter-item').removeClass('table-filter-item--is-applied');
  // Toggle No filters applied label
  $('.js-table-filter-nothing-applied').toggleClass('u-display-none', state.activeFilters.length > 0);

  state.activeFilters.forEach(filter => {
    const { filterGroup } = filter;
    const $filterGroup = $(`.js-table-filter-item[data-filter-group="${filterGroup}"]`);

    appendSingleActiveFilter(filterGroup, filter, $filterGroup);
    $filterGroup.addClass('table-filter-item--is-applied');
    $filterGroup.find(`.js-table-filter-btn[data-filter-name="${filter.name}"]`)
      .addClass('table-filter-btn--is-active');
  });
  if (state.activeFilters.length) {
    $('.js-table-filter').addClass('table-filter--has-applied-filters');
  }
}

/**
 * Displays the number of rows that would be visible after the current filtering is applied.
 */
export function updateRowCount() {
  let numberOfFilters = tableAPI().rows( {search:'applied'} ).count();
  let applyFiltersBtn = $('.js-table-filter-apply');
  let applyBtnDisableText = $('.js-table-filter-apply').attr('disableBtnText');
  $('.js-table-filter-apply-count').text(`(${numberOfFilters})`);

  applyFiltersBtn.prop('disabled', !numberOfFilters);
  applyFiltersBtn.toggleClass('disable-filters-apply', !numberOfFilters);
  applyFiltersBtn.attr(('title', numberOfFilters ? '' : `${applyBtnDisableText}`));
}

/**
 * Removes filter from state active filters fields
 * @param {Object} state
 * @param {String} filterName
 */
export function removeActiveFilterFromState(state, filterName) {
  state.activeFilters = state.activeFilters.filter(item => item.name !== filterName);
}

/**
 * Deep clones state to other state
 * @param {Object} cloneTo - class state that will be reset
 * @param {Object} cloneFrom - class state that will be applied
 */
export function resetState(cloneTo, cloneFrom) {
  cloneTo.activeFilters = JSON.parse(JSON.stringify(cloneFrom.activeFilters));
}

/**
 * Resets all filters on selected table to their initial state
 */
export function resetAllTableFilters() {
  tableAPI().columns().search('', true, false).draw();
}

/**
 * TODO: Refactoring this function
 * Set new filter on a specific column in a table by passing state (state or tempState)
 * @param {Object} tempData - (state or tempState)
 */
export function setNewTableFilter(tempData) {
  tempData.filtersPerColumn = {};

  tempData.activeFilters.forEach(filter => {
    if (!(filter.filterColumn in tempData.filtersPerColumn)) {
      tempData.filtersPerColumn[filter.filterColumn] = [];
    }

    tempData.filtersPerColumn[filter.filterColumn].push(filter.name);
  });

  Object.keys(tempData.filtersPerColumn).forEach((column) => {
    let selectedFilter = tempData.filtersPerColumn[column].join('|');
    tableAPI().column(column).search(`${selectedFilter}`, true, false).draw();
  });
}
